import { useState } from "react";
import { CaretDown, Lightbulb, Warning as WarningIcon, PlayCircle, ArrowSquareOut } from "@phosphor-icons/react";

export default function StepExtrasPanel({ step }) {
  const [open, setOpen] = useState(false);
  const hasExtras =
    (step.description && step.description.trim()) ||
    (step.common_mistakes?.length > 0) ||
    (step.safety_reminders?.length > 0) ||
    (step.related_resources?.length > 0);
  if (!hasExtras) return null;

  return (
    <div className="mt-2" data-testid={`step-extras-${step.id}`}>
      <button
        onClick={() => setOpen(!open)}
        data-testid={`step-extras-toggle-${step.id}`}
        className="flex items-center gap-1 text-xs font-bold text-denim"
      >
        <CaretDown
          size={14}
          weight="bold"
          className={`transition-transform ${open ? "rotate-180" : ""}`}
        />
        {open ? "Hide details" : "Show details"}
      </button>
      {open && (
        <div className="mt-2 space-y-2 border-t border-stone_border pt-2">
          {step.description && (
            <p className="text-sm text-timber-900 leading-relaxed">{step.description}</p>
          )}
          {step.common_mistakes?.length > 0 && (
            <div className="bg-kraft border border-stone_border rounded-lg p-2">
              <p className="label-cap text-[10px] flex items-center gap-1 text-denim">
                <Lightbulb size={12} weight="fill" /> Common mistakes
              </p>
              <ul className="mt-1 text-xs text-timber-900 list-disc pl-5 space-y-0.5">
                {step.common_mistakes.map((m, i) => <li key={i}>{m}</li>)}
              </ul>
            </div>
          )}
          {step.safety_reminders?.length > 0 && (
            <div className="bg-[#FBEDEE] border border-block rounded-lg p-2">
              <p className="label-cap text-[10px] flex items-center gap-1 text-block">
                <WarningIcon size={12} weight="fill" /> Safety
              </p>
              <ul className="mt-1 text-xs text-timber-900 list-disc pl-5 space-y-0.5">
                {step.safety_reminders.map((s, i) => <li key={i}>{s}</li>)}
              </ul>
            </div>
          )}
          {step.related_resources?.length > 0 && (
            <div>
              <p className="label-cap text-[10px] flex items-center gap-1 text-denim mb-1">
                <PlayCircle size={12} weight="fill" /> Watch & learn
              </p>
              <div className="flex flex-wrap gap-1.5">
                {step.related_resources.map((r, i) => (
                  <a
                    key={i}
                    href={r.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`step-resource-${step.id}-${i}`}
                    className="text-xs font-semibold text-denim bg-chalk border border-stone_border rounded-full px-2.5 py-1 flex items-center gap-1 hover:border-masking hover:text-masking transition"
                  >
                    {r.title} <ArrowSquareOut size={11} weight="bold" />
                  </a>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
